import { Close, Lock } from "@mui/icons-material";
import DatasetIcon from "@mui/icons-material/Dataset";
import { Box, Button, Chip, Dialog, DialogContent, DialogTitle, IconButton, List, ListItem, ListItemButton, ListItemText } from "@mui/material";
import ChatInput from "components/ChatInput";
import Container from "components/Container";
import Loading from "components/Loading";
import Main from "layouts/Main";
import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { getDatasetList } from "services/api";
import { Dataset } from "types/dataset";

const Home = () => {
	const { t } = useTranslation(["common", "validation"]);
	const navigate = useNavigate();

	const chatRef = React.useRef<any>(null);

	const [inputValue, setInputValue] = React.useState("");
	const [dataset, setDataset] = React.useState<string>("");
	const [displayDataset, setDisplayDatasets] = React.useState<Dataset[]>([]);
	const [datasets, setDatasets] = React.useState<Dataset[]>([]);
	const [loading, setLoading] = React.useState(true);
	const [moreDatasetOpen, setMoreDatasetOpen] = React.useState(false);

	const handleChange = (id: string) => {
		setDataset(id);
	};

	const openMoreDataset = () => {
		setMoreDatasetOpen(true);
	};

	const handleClose = () => {
		setMoreDatasetOpen(false);
	};

	const handleDatasetClick = (dataset: Dataset) => {
		if (!displayDataset.includes(dataset)) {
			setDisplayDatasets((prev) => [dataset, ...prev.slice(0, 4)]);
		}
		setDataset(dataset.id);
		handleClose();
	};

	const handleSubmit = (): Promise<string> => {
		if (!dataset) return;
		navigate("/app/chat?question=" + inputValue + "&dataset=" + dataset);
	};

	React.useEffect(() => {
		setLoading(true);
		console.log(chatRef.current);
		getDatasetList()
			.then((resp) => {
				if (!resp || resp?.error) return;
				setDatasets(resp.datasets);
				chatRef.current && chatRef.current.updateCredit(resp.credit);

				if (resp.datasets.length > 0) {
					setDisplayDatasets(resp.datasets.slice(0, 5));
					setDataset(resp.datasets[0].id);
				}
			})
			.finally(() => setLoading(false));
	}, []);

	return (
		<Main>
			{loading ? (
				<Loading />
			) : (
				<Container
					height={1}
					display="flex"
					flexDirection="column"
					justifyContent={"center"}
					gap={1}>
					<Box
						height={32}
						display="flex"
						flexDirection={"row"}
						justifyContent={"center"}
						gap={1}>
						{displayDataset.map((item, i) => (
							<Chip
								key={i}
								label={item?.name}
								variant={dataset === item?.id ? "filled" : "outlined"}
								onClick={() => handleChange(item.id)}
								sx={{ minWidth: 40 }}
							/>
						))}
						<Button
							color="inherit"
							startIcon={<DatasetIcon />}
							onClick={openMoreDataset}
							sx={{ minWidth: 40 }}>
							{t("more")}
						</Button>
					</Box>
					<ChatInput
						ref={chatRef}
						handleSubmit={handleSubmit}
						inputValue={inputValue}
						setInputValue={setInputValue}
					/>

					<Dialog
						onClose={handleClose}
						open={moreDatasetOpen}
						fullWidth>
						<DialogTitle
							sx={{ m: 0, p: 2, mr: 5 }}
							id="customized-dialog-title">
							{t("moreDataset")}
						</DialogTitle>
						<IconButton
							aria-label="close"
							onClick={handleClose}
							sx={(theme) => ({
								position: "absolute",
								right: 8,
								top: 12,
								color: theme.palette.grey[500],
							})}>
							<Close />
						</IconButton>
						<DialogContent
							dividers
							sx={{ p: 1 }}>
							<List sx={{ pt: 0 }}>
								{datasets.map((dataset) => (
									<ListItem
										disablePadding
										key={dataset.id}>
										<ListItemButton onClick={() => handleDatasetClick(dataset)}>
											<ListItemText primary={dataset.name} />
											{dataset.mode === "private" && <Lock />}
										</ListItemButton>
									</ListItem>
								))}
							</List>
						</DialogContent>
					</Dialog>
				</Container>
			)}
		</Main>
	);
};

export default Home;
